/***************************************************************************/
"use client";
/***************************************************************************/

import { usePathname } from "next/navigation";

const sortSearchParams = (searchParams: URLSearchParams): URLSearchParams => {
  const sortedSearchParams = new URLSearchParams();

  const keys: string[] = [];
  searchParams.forEach((value, key) => {
    if ((value ?? "").length > 0) {
      keys.push(key);
    }
  });

  keys.sort().forEach((key) => {
    sortedSearchParams.set(key, searchParams.get(key) ?? "");
  });

  return sortedSearchParams;
};

const useVanillaSearchParams = () => {
  const pathname = usePathname();

  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  const getSearchParams = <T extends Record<string, string | undefined>>():
    | T
    | undefined => {
    try {
      const searchParams = new URLSearchParams(window.location.search);

      return Object.fromEntries(searchParams) as T;
    } catch (error) {
      console.error(error);

      return undefined;
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  const setSearchParams = <T extends {}>(
    searchParamsToSet: T,
    options?: { mode?: "Push" | "Replace" },
  ) => {
    const updatedSearchParams = new URLSearchParams(window.location.search);
    Object.keys(searchParamsToSet).forEach((key) => {
      updatedSearchParams.set(
        key,
        searchParamsToSet[key as keyof T]?.toString() ?? "",
      );
    });
    const sortedSearcParams = sortSearchParams(updatedSearchParams);

    (options?.mode === "Push"
      ? window.history.pushState
      : window.history.replaceState)(
      undefined,
      "",
      [pathname, sortedSearcParams.toString()].join("?"),
    );
  };

  return { getSearchParams, setSearchParams };
};

export default useVanillaSearchParams;
